<template>
  <div>
      <div id="box">
        <v-row class="row pa-2">
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <div id="title" :style="{'color':theme}">
            {{title}}
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-autocomplete
              v-model="selectedFilter.CampaignId"
              item-value="id"
              item-text="name"
              :items="filterCampaigns"
              label="Campaign Filter"
              hide-details
              outlined
              auto-select-first
              @change="search"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-autocomplete
              v-model="selectedFilter.UserId"
              item-value="id"
              item-text="name"
              :items="filterUsers"
              label="CC Filter"
              hide-details
              outlined
              auto-select-first
              @change="search"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-menu
              ref="monthPicker"
              v-model="monthPicker"
              :close-on-content-click="false"
              :return-value.sync="selectedMonth"
              transition="scale-transition"
              offset-y
              dense
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Year Month"
                  v-model="searchMonth"
                  readonly
                  clearable
                  outlined
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  @change="search()"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchMonth"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="secondary"
                    @click="monthPicker = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="secondary"
                    @click="searchMonthOk"
                >
                    OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- <v-col cols="12" class="pb-0">
            <v-row justify="center" align="center">
                <v-col cols="12" sm="12" md="6" lg="6">
                    <div id="title" :style="{'color':theme}">
                    {{title}}
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" justify="right" align="right" >
                    <div style="padding:10px 10px 0">
                        <v-select
                            v-model="selectedFilter"
                            item-value="id"
                            item-text="name"
                            :items="filters"
                            label="Filter"
                            hide-details
                            outlined
                            @change="search"
                        ></v-select>
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" justify="right" align="right">
                    <div style="padding:10px 10px 0">
                        <v-menu
                            ref="monthPicker"
                            v-model="monthPicker"
                            :close-on-content-click="false"
                            :return-value.sync="selectedMonth"
                            transition="scale-transition"
                            offset-y
                            dense
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                label="Year Month"
                                v-model="searchMonth"
                                readonly
                                clearable
                                outlined
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                @change="search()"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="searchMonth"
                            type="month"
                            no-title
                            scrollable
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="secondary"
                                @click="monthPicker = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="secondary"
                                @click="searchMonthOk"
                            >
                                OK
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </v-col>
            </v-row>
            <v-divider ></v-divider>
          </v-col> -->
        </v-row>
        <v-divider ></v-divider>
        <v-row class="mg-top-0">
            <v-col cols="12" class="pd-top-0">
                <v-container class="pd-top-0">
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        single-expand
                        :expanded.sync="expanded"
                        :items-per-page="5"
                        class="elevation-1"
                        :key="dataTableKey"
                        show-expand
                    >
                      <template v-slot:[`item.avg_satisfy`]="{ item }">{{item.avg_satisfy}} / 5</template>
                      <template v-slot:[`item.avg_advertiser`]="{ item }">{{item.avg_advertiser}} / 5</template>
                      <template v-slot:[`item.avg_kobe`]="{ item }">{{item.avg_kobe}} / 5</template>
                      <template v-slot:[`item.avg_overall`]="{ item }">{{item.avg_overall}} / 5</template>
                      <template v-slot:expanded-item="{ headers, item}" style="box-shadow:none;">
                          <td :colspan="headers.length" style="border:none;padding:20px;">
                              <v-data-table
                                  :headers="influencerDetailHeaders"
                                  :items="item.influencerRatings"
                                  class="elevation-1"
                              >
                                <template v-slot:[`item.profilePicture`]="{ item }">
                                  <v-avatar :size="avatarSize" color="grey lighten-4">
                                    <img v-bind:src="paserImageUrl(item.profilePicture)" alt="avatar" />
                                  </v-avatar>
                                </template>
                                <template v-slot:[`item.instagramHandle`]="{ item }">
                                  <a
                                    target="_blank"
                                    v-bind:href="'https://instagram.com/' + item.instagramHandle"
                                    v-if="item.instagramHandle"
                                  >@{{ item.instagramHandle }}</a>
                                  <span v-else>N/A</span>
                                </template>
                                <template v-slot:[`item.avg_satisfy`]="{ item }">{{item.avg_satisfy}} / 5</template>
                                <template v-slot:[`item.avg_advertiser`]="{ item }">{{item.avg_advertiser}} / 5</template>
                                <template v-slot:[`item.avg_kobe`]="{ item }">{{item.avg_kobe}} / 5</template>
                                <template v-slot:[`item.avg_overall`]="{ item }">{{item.avg_overall}} / 5</template>
                              </v-data-table>
                          </td>
                      </template>
                    </v-data-table>
                </v-container>
            </v-col>
        </v-row>
      </div>
  </div>
</template>
<script>
// import paymentAPIs from './clientAPIs'

export default {
  name: 'InfluencerQualityRating',
  props: {
    theme: {type: String},
    title: {type: String},
    headers: {type: Array},
    items: {type: Array},
    filterCampaigns: {type: Array},
    filterUsers: {type: Array}
  },
  data: () => ({
    selectedFilter: {CampaignId: '', UserId: ''},
    searchMonth: '',
    selectedMonth: '',
    monthPicker: false,
    dataTableKey: 0,
    expanded: [],
    influencerDetailHeaders: [
      { value: 'profilePicture', text: 'Avatar', sortable: true },
      { value: 'instagramHandle', text: 'instagram Handle', sortable: true },
      { value: 'avg_satisfy', text: 'Average Satisfaction with Campaign', sortable: true },
      { value: 'avg_advertiser', text: 'Average Experience with Advertiser', sortable: true },
      { value: 'avg_kobe', text: 'Average Satisfaction with Kobe', sortable: true },
      { value: 'avg_overall', text: 'Overall Rating', sortable: true }
    ],
    avatarSize: 45 // avatar
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    search() {
      let filter = Object.assign({}, {
        CampaignId: this.selectedFilter.CampaignId,
        UserId: this.selectedFilter.UserId,
        month: this.searchMonth
      });
      this.$emit('searchfilter', filter)
    },
    searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.search();
    },
    paserImageUrl(url) {
      if (!url) return '';
      var newUrl = url
        .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
        .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    }
  }
}
</script>
<style scoped>
.mg-top-0 {
  margin-top: 0px !important;
}

.mg-bottom-0 {
  margin-bottom: 0px !important;
}

.mg-bottom-10 {
  margin-bottom: 10px !important;
}

.pd-bottom-0 {
  padding-bottom: 0px !important;
}

.pd-top-0 {
  padding-top: 0px !important;
}

.filter-pad {
    padding:10px 0 0px 10px;
}

#box {
  /* width: 366px; */
  /* min-height: 430px; */

  border: 0.8px solid #E5E5E5;
  box-sizing: border-box;
}

#title {
  /* width: 366px; */
  height: 46px;

  font-family: WorkSans-Medium;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 45px;

  padding-left:17px;
  padding-top:5px;
}

#avg {
  padding-top:10px;
  /* height: 28px; */
  left: calc(50% - 304px/2 - 1px);
  top: calc(50% - 28px/2 - 7.5px);

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

#avgTitle {
  /* width: 309px; */
  height: 12px;
  left: calc(50% - 309px/2 - 3.5px);
  top: calc(50% - 12px/2 + 18.5px);
  padding-top:5px;

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
/* identical to box height */

  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

.left-div-border {
  border-left: 4px solid;
  height: 35px;
  width: 4px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// InfluencerQualityRating.vue?70d94506